import { render } from "./LegInfo.vue?vue&type=template&id=62be5f02&scoped=true&lang=pug"
import script from "./LegInfo.vue?vue&type=script&lang=ts"
export * from "./LegInfo.vue?vue&type=script&lang=ts"

import "./LegInfo.vue?vue&type=style&index=0&id=62be5f02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62be5f02"

export default script